import React from 'react'
import type { FilteredRestaurant, RestaurantShortDTO } from 'shared/types'
import { RestaurantModal } from 'app/common/modals'

type Props = {
    isOpen: boolean,
    loading?: boolean,
    restaurants: Array<FilteredRestaurant>,
    addRestaurant: RestaurantShortDTO => void,
    selectRestaurant: RestaurantShortDTO => void,
    selectedRestaurant: RestaurantShortDTO,
    resetAddRestaurantSuccess: () => void,
    handleClose: () => void,
    addRestaurantSuccess: boolean,
    addRestaurantError: string
}

const AddFavoriteRestaurantComponent = (props: Props) => (
    <RestaurantModal {...props} fromKingdom />
)

export { AddFavoriteRestaurantComponent }
